import React from 'react';
import { Award, BookOpen, Target, TrendingUp } from 'lucide-react';
import { Link } from 'react-router-dom';
import { mockData } from '../mock';

const About = () => {
  return (
    <div className="min-h-screen pt-32 md:pt-36">
      {/* About Hero */}
      <section className="py-16 md:py-24">
        <div className="container">
          <div className="max-w-4xl mx-auto text-center mb-16">
            <h1 className="display-large mb-6">About FITNOVEXA</h1>
            <p className="body-large">
              For over 20 years, we've been at the forefront of fitness, wellness and recreation industry, 
              helping businesses and professionals bridge traditional practices with next-generation solutions.
            </p>
          </div>

          {/* Mission Cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
            <div className="network-card text-center">
              <div className="bg-[#D3FF62] w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <Target size={32} className="text-[#004534]" />
              </div>
              <h3 className="heading-3 mb-3">Our Mission</h3>
              <p className="body-medium">
                Transform fitness, wellness and recreation through innovative technology solutions
              </p>
            </div>
            <div className="network-card text-center">
              <div className="bg-[#D3FF62] w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <TrendingUp size={32} className="text-[#004534]" />
              </div>
              <h3 className="heading-3 mb-3">Our Vision</h3>
              <p className="body-medium">
                Lead the industry in digital transformation and system optimization
              </p>
            </div>
            <div className="network-card text-center">
              <div className="bg-[#D3FF62] w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <Award size={32} className="text-[#004534]" />
              </div>
              <h3 className="heading-3 mb-3">Our Values</h3>
              <p className="body-medium">
                Innovation, Excellence, and Proven Results in every project
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Founder Section */}
      <section className="py-16 md:py-24 bg-[#FAFAFF]">
        <div className="container">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Founder Image */}
            <div className="order-2 lg:order-1">
              <div className="relative rounded-[32px] overflow-hidden shadow-2xl">
                <img
                  src="https://images.unsplash.com/photo-1758875570137-8691b7c55033"
                  alt="Oz Altun, PhD - Founder & CEO"
                  className="w-full h-auto object-cover"
                />
              </div>
            </div>

            {/* Founder Info */}
            <div className="order-1 lg:order-2">
              <div className="inline-block bg-[#D3FF62] px-4 py-2 rounded-full mb-6">
                <span className="text-[#004534] font-semibold text-sm">Founder & CEO</span>
              </div>
              <h2 className="heading-1 mb-4">{mockData.founderInfo.name}</h2>
              <p className="body-large mb-4 text-[#0C6951] font-semibold">
                {mockData.founderInfo.degree}
              </p>
              <p className="body-medium mb-6">
                Specialization: {mockData.founderInfo.specialization}
              </p>
              <p className="body-medium mb-8">
                {mockData.founderInfo.bio}
              </p>

              {/* Credentials */}
              <div className="space-y-3">
                <h3 className="heading-3 mb-4">Credentials & Achievements</h3>
                {mockData.founderInfo.credentials.map((credential, index) => (
                  <div key={index} className="flex items-start gap-3">
                    <div className="bg-[#D3FF62] rounded-full p-1 mt-1">
                      <Award size={16} className="text-[#004534]" />
                    </div>
                    <p className="body-medium">{credential}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose FITNOVEXA */}
      <section className="py-16 md:py-24">
        <div className="container">
          <div className="text-center mb-12">
            <h2 className="heading-1 mb-4">Why Choose FITNOVEXA?</h2>
            <p className="body-large max-w-2xl mx-auto">
              Unique advantages that set us apart in the industry
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="network-card">
              <h3 className="heading-3 mb-3">20+ Years of Expertise</h3>
              <p className="body-medium">
                Two decades of proven experience in fitness and recreation technology integration
              </p>
            </div>
            <div className="network-card">
              <h3 className="heading-3 mb-3">Doctoral-Level Leadership</h3>
              <p className="body-medium">
                Led by Oz Altun, PhD with specialized knowledge in physical activity intervention technologies
              </p>
            </div>
            <div className="network-card">
              <h3 className="heading-3 mb-3">Comprehensive Solutions</h3>
              <p className="body-medium">
                From consulting to products, we offer end-to-end technology transformation services
              </p>
            </div>
            <div className="network-card">
              <h3 className="heading-3 mb-3">Industry Pioneer</h3>
              <p className="body-medium">
                Setting standards for digital fitness transformation and system optimization
              </p>
            </div>
            <div className="network-card">
              <h3 className="heading-3 mb-3">Proven Track Record</h3>
              <p className="body-medium">
                Successfully implemented technology solutions across diverse fitness and recreation businesses
              </p>
            </div>
            <div className="network-card">
              <h3 className="heading-3 mb-3">Client-Focused Approach</h3>
              <p className="body-medium">
                Customized solutions tailored to your specific needs and business goals
              </p>
            </div>
          </div>
          
          <div className="text-center mt-12">
            <Link to="/contact" className="btn-primary">
              Partner With Us
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;